/* eslint-disable react/react-in-jsx-scope */
import { SearchFunction } from 'entities-next/searchFunctions'
import OpenInNewIcon from 'mdi-react/OpenInNewIcon'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

import { Corporate } from '../../../../../../../entities-next/corporate'
import { getCorporateDetailsFormDataPath } from '../../../../CorporateManager/scenes/CorporateDetailsView/CorporateDetailsView.routes'
import { getScoutingCampaignDetailsFormDataPath } from '../../../../ScoutingCampaignManager/scenes/ScoutingCampaignDetailsView/ScoutingCampaignDetailsView.routes'

export type DealSearchFunctionInfoProps = ExtendableStyles & {
  searchFunction?: SearchFunction
  corporate?: Corporate
}

export function DealInfoHeader({ corporate, searchFunction }: DealSearchFunctionInfoProps) {
  const { classes } = useStyles()

  if (!searchFunction) {
    return <Typography>No configured Space</Typography>
  }

  return (
    <div>
      <span className={classes.flex}>
        <strong>Space: </strong>
        <span>
          {searchFunction.name} (id:{searchFunction.id})
        </span>
        <a target="_blank" href={getScoutingCampaignDetailsFormDataPath(searchFunction.id)} rel="noopener noreferrer">
          <OpenInNewIcon className={classes.icon} />
        </a>
      </span>
      {corporate && (
        <p className={classes.flex}>
          <strong>Corporate: </strong>
          <span>
            {corporate.name} (id:{corporate.id})
          </span>
          <a target="_blank" href={getCorporateDetailsFormDataPath(corporate.id)} rel="noopener noreferrer">
            <OpenInNewIcon className={classes.icon} />
          </a>
        </p>
      )}
    </div>
  )
}

const useStyles = makeStyles()(({ palette, spacing }: Theme) => ({
  infoSection: {
    marginTop: spacing(2),
  },
  flex: {
    display: 'flex',
    justifyItems: 'center',
    gap: spacing(0.5),
  },
  icon: {
    fill: palette.primary.main,
    color: palette.primary.main,
  },
}))
